var _path, _path2, _g, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinningLogo = function SvgSpinningLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.566 0H54.252v38.867h39.47V7.155A7.155 7.155 0 0 0 86.565 0Z",
    fill: "#F0AC00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h39.47v38.867H0V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.47 0H7.156A7.156 7.156 0 0 0 0 7.155v31.712h39.47V0Z",
    fill: "#B7B7B7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.566 93.722H54.252V54.855h39.47v31.712a7.155 7.155 0 0 1-7.156 7.155Z",
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 54,
    width: 40,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 54.855h39.47v38.867H0V54.855Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.47 93.722H7.156A7.156 7.156 0 0 1 0 86.567V54.855h39.47v38.867Z",
    fill: "#2762E9"
  }))));
};
export { SvgSpinningLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTQiIGhlaWdodD0iOTQiIHZpZXdCb3g9IjAgMCA5NCA5NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ni41NjY0IDBINTQuMjUyNFYzOC44NjdIOTMuNzIxNFY3LjE1NUM5My43MjE0IDMuMjA0IDkwLjUxODQgMCA4Ni41NjY0IDBaIiBmaWxsPSIjRjBBQzAwIi8+CjxtYXNrIGlkPSJtYXNrMF8yNTRfMTg3NzEiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MCIgaGVpZ2h0PSIzOSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwSDM5LjQ2OTdWMzguODY3SDBWMFoiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8yNTRfMTg3NzEpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zOS40Njk4IDBINy4xNTU3NkMzLjIwMzc2IDAgLTAuMDAwMjQ0MTQxIDMuMjA0IC0wLjAwMDI0NDE0MSA3LjE1NVYzOC44NjdIMzkuNDY5OFYwWiIgZmlsbD0iI0I3QjdCNyIvPgo8L2c+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNODYuNTY2NCA5My43MjE4SDU0LjI1MjRWNTQuODU0OEg5My43MjE0Vjg2LjU2NjhDOTMuNzIxNCA5MC41MTc4IDkwLjUxODQgOTMuNzIxOCA4Ni41NjY0IDkzLjcyMThaIiBmaWxsPSIjMTIxMjEyIi8+CjxtYXNrIGlkPSJtYXNrMV8yNTRfMTg3NzEiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjU0IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgNTQuODU0OEgzOS40Njk3VjkzLjcyMThIMFY1NC44NTQ4WiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2sxXzI1NF8xODc3MSkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM5LjQ2OTggOTMuNzIxOEg3LjE1NTc2QzMuMjAzNzYgOTMuNzIxOCAtMC4wMDAyNDQxNDEgOTAuNTE3OCAtMC4wMDAyNDQxNDEgODYuNTY2OFY1NC44NTQ4SDM5LjQ2OThWOTMuNzIxOFoiIGZpbGw9IiMyNzYyRTkiLz4KPC9nPgo8L3N2Zz4K";